
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcSlideButton as ObcSlideButtonElement} from '@oicl/openbridge-webcomponents/dist/components/slide-button/slide-button.js';
 import {ObcSlideButtonSlideEvent} from '@oicl/openbridge-webcomponents/dist/components/slide-button/slide-button.js';
 export type {ObcSlideButtonSlideEvent} from '@oicl/openbridge-webcomponents/dist/components/slide-button/slide-button.js';
 

 
 export const ObcSlideButton = createComponent({
   react: React,
   tagName: 'obc-slide-button',
   elementClass: ObcSlideButtonElement,
   events: {
     
     onSlide: 'slide' as EventName<ObcSlideButtonSlideEvent>,
   }
  });
 
 